<div class="flex-column justify-content-between align-items-center">
  <div class="d-flex w-100 justify-content-between">
    <div class="flexStart">
      <div class="other-section-title">
        <fa-icon icon="ellipsis-v" size="3x"
                 class="ms-2 me-2 vid-fa-icon-black"></fa-icon>
        <span class="section-title">{{ 'AUTHENTICATORS.OTHER' | translate }}
          </span>
      </div>
    </div>
  </div>
  <div class="m-4 alert alert-secondary vid-list-item-description" role="alert">
    {{ 'AUTHENTICATORS.HELP_OTHER_AUTHENTICATORS' | translate }}
  </div>
  <div class="mt-3 mb-3 ms-4 me-4">
      <ngx-datatable class="fullscreen" [columnMode]="ColumnMode.flex" [headerHeight]="30"
                     [footerHeight]="80" rowHeight="auto" [rows]="deviceAuthenticator().authenticators"
                     [selectionType]="SelectionType.single">
        <ngx-datatable-column [flexGrow]="2" name="" prop="type" [sortable]="false">
          <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div class="pt-2 pb-1 fs-7">
              @switch (iconMapping()[value]?.type) {
                @case ("icon") {
                  <fa-icon [icon]="iconMapping()[value]?.icon" size="3x"
                           class="vid-fa-icon-black m1"
                           [ngStyle]="iconMapping()[value]?.style"></fa-icon>
                }
                @case ("image") {
                  <img [src]="iconMapping()[value]?.src" class="fido_logo"/>
                }
              }
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [flexGrow]="3" [name]="'AUTHENTICATORS.TYPE' | translate" prop="type">
          <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div *ngIf="row.type === 'PIN'" class="mt-2">
              <span>{{ 'AUTHENTICATORS.INDEPENDENT_PIN' | translate }}</span>
            </div>
            <div *ngIf="row.type !== 'PIN'" class="mt-2">
              <span>{{ 'AUTHENTICATORS.' + row.type | translate }}</span>
              <span *ngIf="row.type==='FIDO'">{{ row.fidoCalculatedName }}</span>
              <span *ngIf="row.type ==='SW_OTP'
                                            || row.type === 'HW_OTP'">{{ ' - ' + row.name }}</span>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [flexGrow]="3" [name]="'AUTHENTICATORS.STATUS' | translate" prop="status">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <div style="display: flex">
              <div>
              <span
                *ngIf="value==='ACTIVATED'"
                class="mt-2 vid-badge badge bg-success">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
                <span
                  *ngIf="value==='LOST'"
                  class="mt-2 vid-badge badge bg-danger">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
                <span
                  *ngIf="value==='EXPIRED'"
                  class="mt-2 vid-badge badge bg-warning text-dark">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
                <span
                  tooltip="{{'AUTHENTICATORS.STATUS_EXPIRING_EXPLANATION' | translate: {days: row.details['expiringInDays']} }}"
                  container="body" [adaptivePosition]="false" placement="top"
                  *ngIf="value==='EXPIRING'"
                  class="mt-2 vid-badge badge bg-warning text-dark">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
                <span
                  *ngIf="value==='DISABLED'"
                  class="mt-2 vid-badge badge bg-secondary">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
                <span
                  *ngIf="value ==='BLOCKED_BY_ADMIN'"
                  class="mt-2 vid-badge badge bg-danger">{{ 'AUTHENTICATORS.STATUS_' + value | translate }}</span>
              </div>
              <div
                *ngIf="row.type === 'FIDO' && row.details?.dormant === 'true'"
                [hidden]=""
                style="margin-left: 5px; margin-top: 5px">
                <div class="vid-badge badge bg-warning text-dark">
                  <img src='assets/nucleo/icons8-sleep-16.png'
                       tooltip="{{'AUTHENTICATORS.DORMANT_MESSAGE' | translate}}" container="body"
                       [adaptivePosition]="false"
                       placement="top" width="13" height="13">
                </div>
              </div>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [flexGrow]="4" [name]="'AUTHENTICATORS.REG_TIME' | translate" prop="registrationDate">
          <ng-template let-value="value" ngx-datatable-cell-template>
            <div class="mt-2">
              {{ value | isoDateTime }}
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [flexGrow]="3" [name]="'AUTHENTICATORS.ACTIONS' | translate" prop="id"
                              [sortable]="false">
          <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <button id="removeAuthBtn" *ngIf="((row.type === 'SMS'
                                         || row.type === 'FIDO'
                                         || row.type === 'DESKTOP_FACE'
                                         || row.type === 'TOTP_DESKTOP'
                                         || row.type === 'YUBICO_OTP'
                                         || row.type === 'SW_OTP'
                                         || row.type === 'HW_OTP'
                                         || row.type === 'DESKTOP_FINGERPRINT')
                                         && !hideRemoveAuthenticatorsButton() && row.status !== 'BLOCKED_BY_ADMIN')"
                    (click)="removeAuth(row)" type="button"
                    class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.REMOVE' | translate }}
            </button>
            <button id="resetPinBtn" *ngIf="row.type == 'PIN' && deviceAuthenticator().status != 'BLOCKED_BY_ADMIN'"
                    (click)="resetPin()" type="button"
                    class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.RESET' | translate }}
            </button>
            <button tooltip="{{'AUTHENTICATORS.RESET_BUTTON' | translate}}" container="body"
                    [adaptivePosition]="false"
                    placement="top"
                    *ngIf="row.type == 'LDAP_PASSWORD' && adPasswordSelfReset && row.status !== 'BLOCKED_BY_ADMIN'"
                    (click)="resetLdapPassword('LDAP_PASSWORD_RESET',row)" type="button"
                    class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.RESET' | translate }}
            </button>
            <button tooltip="{{'AUTHENTICATORS.RENEW_BUTTON' | translate}}" container="body"
                    [adaptivePosition]="false"
                    placement="top"
                    *ngIf="row.type == 'LDAP_PASSWORD' && adPasswordSelfRenewal && row.status !== 'BLOCKED_BY_ADMIN'"
                    (click)="resetLdapPassword('LDAP_PASSWORD_RENEW', row)" type="button"
                    class="mt-2 vid-btn vid-btn-xs">{{ 'AUTHENTICATORS.RENEW' | translate }}
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
  </div>
</div>
